/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlTrialUpdateRequest
 */
export interface ControlTrialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlTrialUpdateRequest
     */
    start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTrialUpdateRequest
     */
    end_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTrialUpdateRequest
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the ControlTrialUpdateRequest interface.
 */
export function instanceOfControlTrialUpdateRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlTrialUpdateRequestFromJSON(json: any): ControlTrialUpdateRequest {
    return ControlTrialUpdateRequestFromJSONTyped(json, false);
}

export function ControlTrialUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTrialUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start_date': !exists(json, 'start_date') ? undefined : json['start_date'],
        'end_date': !exists(json, 'end_date') ? undefined : json['end_date'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function ControlTrialUpdateRequestToJSON(value?: ControlTrialUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start_date': value.start_date,
        'end_date': value.end_date,
        'enabled': value.enabled,
    };
}

